import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ClientService } from '../../../services/client.service';

declare var $: any;

@Component({
  selector: 'ngx-work-client',
  templateUrl: './client.component.html',
})
export class ClientComponent implements OnInit {

  private _pet_no: number;
  private _client_no: number;
  info = true;
  family = false;
  contacts = false;
  emails = false;
  appts = false;
  finantial = false;
  notes = false;
  recall = false;
  documents = false;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
  }

  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set client_no(value: number) {
    this.clientService.getClientFamily(value).then(() => { });
    this.clientService.getClientContact(value).then(() => { });
    this.clientService.getClientAppt(value).then(() => { });
    this.clientService.getClientCashReg(value).then(() => { });
    this.petService.GetNotesByClientId(value).then(() => { });
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public clientService: ClientService,
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.clientService.changeClient
      .subscribe(message => {
        if (message !== this.client_no) {
          this.client_no = message;
        }
      });

    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  add() {
    $('#modalNewPetNote').modal('toggle')
  }

  edit(item) {
    this.petService.pet_note = item;
    $('#modalNewPetNote').modal('toggle')
  }

  ver(tipo: string) {
    this.info = tipo === 'info'
    this.family = tipo === 'family'
    this.contacts = tipo === 'contacts'
    this.emails = tipo === 'emails'
    this.appts = tipo === 'appts'
    this.finantial = tipo === 'finantial'
    this.notes = tipo === 'notes'
    this.recall = tipo === 'recall'
    this.documents = tipo === 'documents'
  }
}
